import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { CommentaryPageStateModuleName } from '@/store/modules/modules'

export class CommentaryPageStateViewModel {
  private store = useStore()

  isPreCommentaryFirstTimeOpendPage: ComputedRef<boolean> = computed(
    () => this.store.getters[`${CommentaryPageStateModuleName}/isPreCommentaryFirstTimeOpendPage`]
  )
  isPostCommentaryFirstTimeOpendPage: ComputedRef<boolean> = computed(
    () => this.store.getters[`${CommentaryPageStateModuleName}/isPostCommentaryFirstTimeOpendPage`]
  )
  preCommentarySelectedList: ComputedRef<{ [type: string]: number }> = computed(
    () => this.store.getters[`${CommentaryPageStateModuleName}/preCommentarySelectedList`]
  )
  postCommentarySelectedList: ComputedRef<{ [type: string]: number }> = computed(
    () => this.store.getters[`${CommentaryPageStateModuleName}/postCommentarySelectedList`]
  )
  preCommentaryList: ComputedRef<{ [type: string]: { [filter: string]: string } }> = computed(
    () => this.store.getters[`${CommentaryPageStateModuleName}/preCommentaryList`]
  )
  postCommentaryList: ComputedRef<{ [type: string]: { [filter: string]: string } }> = computed(
    () => this.store.getters[`${CommentaryPageStateModuleName}/postCommentaryList`]
  )

  setIsPreCommentaryFirstTimeOpendPage(flag: boolean): void {
    this.store.commit(`${CommentaryPageStateModuleName}/setIsPreCommentaryFirstTimeOpendPage`, { flag })
  }

  setIsPostCommentaryFirstTimeOpendPage(flag: boolean): void {
    this.store.commit(`${CommentaryPageStateModuleName}/setIsPostCommentaryFirstTimeOpendPage`, { flag })
  }

  setPreCommentarySelected(type: string, index: number): void {
    this.store.commit(`${CommentaryPageStateModuleName}/setPreCommentarySelected`, { type, index })
  }

  setPostCommentarySelected(type: string, index: number): void {
    this.store.commit(`${CommentaryPageStateModuleName}/setPostCommentarySelected`, { type, index })
  }

  initPreCommentarySelectedList(): void {
    this.store.commit(`${CommentaryPageStateModuleName}/initPreCommentarySelectedList`)
  }

  initPostCommentarySelectedList(): void {
    this.store.commit(`${CommentaryPageStateModuleName}/initPostCommentarySelectedList`)
  }

  setPreCommentary(type: string, filter: string, commentary: string): void {
    this.store.commit(`${CommentaryPageStateModuleName}/setPreCommentary`, { type, filter, commentary })
  }

  setPostCommentary(type: string, filter: string, commentary: string): void {
    this.store.commit(`${CommentaryPageStateModuleName}/setPostCommentary`, { type, filter, commentary })
  }

  initPreCommentaryList(): void {
    this.store.commit(`${CommentaryPageStateModuleName}/initPreCommentaryList`)
  }

  initPostCommentaryList(): void {
    this.store.commit(`${CommentaryPageStateModuleName}/initPostCommentaryList`)
  }

  initCommentaryPagesState(): void {
    this.setIsPreCommentaryFirstTimeOpendPage(true)
    this.setIsPostCommentaryFirstTimeOpendPage(true)
    this.initPreCommentarySelectedList()
    this.initPostCommentarySelectedList()
    this.initPreCommentaryList()
    this.initPostCommentaryList()
  }
}
